import { WaypointType } from "./waypoint.js";
import React from "react";
export class PerimeterSearchContextMenu extends React.Component<PerimeterSearchContextMenuProps, any>{
    private _perimeterSearchOptionsRef: HTMLDivElement;

    private _setRef = (ref: HTMLDivElement) => {
        this._perimeterSearchOptionsRef = ref;
    }

    private _getStyle = () => {
        const leftString = this.props.left != null ? this.props.left.toString() + "px" : null;
        const topString = this.props.top != null ? this.props.top.toString() + "px" : null;
        return { left: leftString, top: topString };
    }

    //Nötig, da ggf. auch von außen die Klasse entfernt wird
    setVisible = (left: number, top: number) => {
        this._perimeterSearchOptionsRef.style.left = left.toString() + "px";
        this._perimeterSearchOptionsRef.style.top = top.toString() + "px";
        this._perimeterSearchOptionsRef.classList.add("geomap__context-menu--hovered");
    }

    setInvisible = () => {
        this._perimeterSearchOptionsRef.classList.remove("geomap__context-menu--hovered");
    }

    render() {
        return (<div ref={this._setRef} className="geomap__context-menu" style={this._getStyle()}>
            <div onClick={() => this.props.onEntryClick(WaypointType.ADDRESS)} >
                {this.props.translations.address}
            </div>
            <div onClick={() => this.props.onEntryClick(WaypointType.MACHINE)} >
                {this.props.translations.machine}
            </div>
            <div onClick={() => this.props.onEntryClick(WaypointType.RESOURCE)} >
                {this.props.translations.resource}
            </div>
            <div onClick={() => this.props.onEntryClick(WaypointType.ASSIGNMENT)} >
                {this.props.translations.assignment}
            </div>
            <div onClick={() => this.props.onEntryClick(WaypointType.TICKET)} >
                {this.props.translations.ticket}
            </div>
        </div>)
    }
}

interface PerimeterSearchContextMenuProps {
    translations: PerimeterSearchContextMenuTranslations,
    left?: number,
    top?: number,
    onEntryClick: (waypointType: WaypointType) => any
}

export interface PerimeterSearchContextMenuTranslations {
    address: string,
    machine: string,
    resource: string,
    assignment: string,
    ticket: string
}